export default __webpack_public_path__ + "static/media/leomax_big.00955291.png";